<template>
  <div>

    <el-row>
      <el-col :span="17">
        <!-- 面包屑导航区域-->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
          <el-breadcrumb-item>Setup</el-breadcrumb-item>
          <el-breadcrumb-item>Brand</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
      <!-- <el-col class="el-breadcrumb__inner" font-size="3px" :span="6">
        Updating Time: {{ this.updateTime }}
        </el-col> -->
    </el-row>
    <!--卡片视图区域-->

    <el-card>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <div v-if="this.userName.toUpperCase()==='J3P'">
          <el-form-item label="Brand Code:" label-width="115px">
            <el-cascader v-model="formInline.brands" style="margin-left: 0px;" :show-all-levels="false" placeholder="please choose"
                         :options="brandOptions"
                         :props="this.props"
                         collapse-tags
                         clearable></el-cascader>
          </el-form-item>
          <el-form-item label="Brand Name:" label-width="115px">
            <el-input v-model="formInline.brandName" placeholder="Brand Name" clearable></el-input>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" @click="onSubmit">Search</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="brandDialogOpen">Add</el-button>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="Brand:" label-width="115px">
            <el-select v-model="formInline.brands" multiple collapse-tags
                       style="margin-left: 0px;" filterable
                       placeholder="please choose">
              <el-option
                v-for="item in this.brandParaList"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Brand Name:" label-width="115px">
            <el-input v-model="formInline.brandName" placeholder="Brand Name" clearable></el-input>
          </el-form-item>
          <el-form-item >
            <el-button type="primary" @click="onSubmit">Search</el-button>
          </el-form-item>
        </div>

        <!-- <el-form-item label="Customer Code:"  v-if="this.userName.toUpperCase()==='J3P'">
          <el-input v-model="formInline.customerCode" placeholder="Customer Code" clearable></el-input>
        </el-form-item>
        <el-form-item label="Brand Code:"  v-if="this.userName.toUpperCase()==='J3P' || this.userName.toUpperCase()==='IP'">
          <el-input v-model="formInline.brandCode" placeholder="Brand Code" clearable></el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" @click="onSubmit">Search</el-button>
          </el-form-item>
          <el-form-item>
          <el-button type="primary" @click="brandDialogOpen" v-if="this.userName.toUpperCase()==='J3P'">Add</el-button>
         </el-form-item> -->
      </el-form>
      <el-dialog title="Brand"
                 width="50%" :visible.sync="dialogFormVisible" @close="editDialogClosed">
        <el-form :model="brandOpenform" label-width="200px" :rules="editFormRules" ref="brandOpenform">
          <el-form-item label="Brand Code:" prop="brand.code">
            <el-input v-model="brandOpenform.brand.code" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item label="Brand Name:" prop="brand.name">
            <el-input v-model="brandOpenform.brand.name" style="width: 300px"></el-input>
          </el-form-item>
          <el-form-item label="Customer Code:" prop="customerCode">
            <el-select v-model="brandOpenform.customerCode" filterable collapse-tags clearable
                       style="margin-left: 0px;width: 300px" :remote-method="remoteMethodCustomer" :loading="loading"
                       placeholder="please choose">
              <el-option
                v-for="item in this.customerList"
                :key="item.code"
                :label="item.code"
                :value="item.code">
                <span style="float: left">{{ item.code }}</span>
                <span style="float: right; margin-right: 30px; color: #8492a6; font-size: 13px">{{ item.name }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Date Range:" prop="brand.dateRange">
            <el-date-picker
              v-model="brandOpenform.brand.dateRange"   value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">Cancel</el-button>
          <el-button type="primary" @click="brandDialogSave('brandOpenform')">Save</el-button>
        </div>
      </el-dialog>

      <!-- CRProject 列表区域 -->
      <el-table :data="brandList" border stripe style="width: 100%">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column v-if="this.userName.toUpperCase()==='J3P'"
                         prop="customerCode"
                         label="Customer Code"         sortable
                         width="150">
        </el-table-column>
        <el-table-column
          prop="brandCode"
          label="Brand Code"         sortable
          width="120">
        </el-table-column>
        <el-table-column
          prop="brandName"      sortable
          label="Brand Name"
          width="250">
        </el-table-column>
        <el-table-column
          prop="rangestart"           :formatter="dateFormat"
          label="Date Range Start"
          width="160">
        </el-table-column>
        <el-table-column
          prop="rangeend"          :formatter="dateFormat"
          label="Date Range End"
          width="150">
        </el-table-column>
        <el-table-column v-if="this.userName.toUpperCase()==='J3P'"
                         label="Operation"
                         width="350">
          <template slot-scope="props">
            <!-- <el-button type="info" plain size="mini" @click="view(props.row.id)">View</el-button> -->
            <el-button type="info" plain size="mini" @click="edit(props.row.brandCode, props.row.customerCode)">Edit</el-button>
            <el-button type="info" plain size="mini" @click="del(props.row.brandCode)">Delete</el-button>
          </template>
        </el-table-column>

      </el-table>

      <!-- 分页区域-->
      <!-- <el-pagination
           @size-change="handleSizeChange"
           @current-change="handleCurrentChange"
           :current-page.sync="formInline.page"
           :page-sizes="[10, 20, 30, 50, 100, total]"
           :page-size="formInline.rows"
           layout="total, sizes, prev, pager, next, jumper"
           :total="total">
         </el-pagination> -->
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formInline: {
        // customerCode: '',
        brands: [],
        brandName: ''
        // dateRange: '',
        // token: ''
        // page: 1,
        // rows: 100
      },
      userName: '',
      brandParam: {
        userName: '',
        userType: ''
      },
      brandParaList: [],
      brandList: [],
      brandOptions: [],
      props: { multiple: true },
      brandOpenform: {
        brand: {
          id: -1,
          code: '',
          name: '',
          dateRange: ''
        },
        customerCode: ''
      },
      loading: false,
      operation: '',
      brandListbak: [],
      customerList: [],
      dialogFormVisible: false,
      editFormRules: {
        brand: {
          code: [
            { required: true, trigger: 'blur', message: 'Required' }
          ],
          name: [
            { required: true, trigger: 'blur', message: 'Required' }
          ],
          dateRange: [
            { required: true, trigger: 'blur', message: 'Required' }
          ]
        },
        customerCode: [
          { required: true, trigger: 'blur', message: 'Required' }
        ]
      }
    }
  },
  created () {
    this.userName = window.sessionStorage.getItem('username')
    this.formInline.token = window.sessionStorage.getItem('token')
    if (this.userName.toUpperCase() === 'J3P') {
      this.getOptions()
    } else {
      this.getbrandPara()
    }
    this.brandParam.userName = this.userName
    this.brandParam.userType = window.sessionStorage.getItem('userType')
    this.getBrands()
  },
  methods: {
    onSubmit () {
      console.log('submit!')
      this.formInline.page = 1
      this.getBrands()
    },
    async brandDialogOpen () {
      this.brandOpenform.brand = { id: -1, code: '', name: '', dateRange: ['2023-01-01', '2032-12-31'] }
      this.operation = 'add'
      this.getCustomers()

      this.dialogFormVisible = true
    },
    async getbrandPara () {
      const { data: res } = await this.$http.get('/common/brandList', { params: this.brandParam })
      this.brandParaList = await res.brands
    },
    async getOptions () {
      const { data: res } = await this.$http.get('/customerBrand/getOptions')
      this.brandOptions = await res.rows
    },
    async edit (value, customerCode) {
      this.operation = 'edit'
      this.dialogFormVisible = true
      this.getCustomers()

      const { data: res } = await this.$http.get('/customerBrand/getBrand', { params: { value: value } })

      this.brandOpenform.brand = res.brand

      if (res.brand.rangeStart !== null) {
        res.brand.rangeStart = res.brand.rangeStart.substr(0, 10).replace('/', '-').replace('/', '-')
      }
      if (res.brand.rangeEnd !== null) {
        res.brand.rangeEnd = res.brand.rangeEnd.substr(0, 10).replace('/', '-').replace('/', '-')
      }

      // this.brandOpenform.dateRange[0] = res.rangeStart
      // this.brandOpenform.dateRange[1] = res.rangeEnd
      console.log('this.brandOpenform.brand === ' + this.brandOpenform.brand.code)

      await this.$set(this.brandOpenform.brand, 'dateRange', [res.brand.rangeStart, res.brand.rangeEnd])

      this.brandOpenform.customerCode = customerCode
      console.log('qqqqqqq')
    },
    async view (value) {
      this.operation = 'view'
      this.dialogFormVisible = true
    },
    remoteMethodCustomer (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.customerList = this.customerListbak.filter(item => {
            return item.code.toLowerCase()
              .indexOf(query.toLowerCase()) > -1 || item.name.toLowerCase()
              .indexOf(query.toLowerCase()) > -1
          })
        }, 200)
      } else {
        this.customerList = this.customerListbak
      }
    },
    async brandDialogSave (formName) {
      var flag = false
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log('已提交表单')
          flag = true
          // const { data: res } = this.$http.post('/brandBrand/brandSave', { params: this.brandOpenform })
          // setTimeout(() => {
          //   console.log('res.errMsg ===' + res.errMsg + '111')
          //   if (res.errMsg !== '') {
          //     this.$alert('Warning', '1111111')
          //   } else {
          //     this.dialogFormVisible = false
          //     this.$message.success('1111111111111111')
          //     this.getbrands()
          //   }
          // }, 900)
        } else {
          console.log('error submit!!')
          return false
        }
      })
      if (flag === true) {
        const { data: res } = await this.$http.post('/customerBrand/brandSave', { params: this.brandOpenform })
        setTimeout(() => {
          console.log('res.errMsg ===' + res.errMsg + '111')
          if (res.errMsg !== '') {
            this.$alert(res.errMsg, 'Warning')
          } else {
            this.dialogFormVisible = false
            this.$message.success('Update Successfully!')
            this.getBrands()
          }
        }, 200)
      }
    },
    editDialogClosed () {
      this.$refs.brandOpenform.resetFields()
    },
    handleClick (tab, event) {
      console.log(tab, event)
    },
    // exportToExcel () {
    //   /* 表示在当前页面打开新地址 */
    //   window.open('http://51.68.206.7:8081/show/exportMoq?token=' + encodeURIComponent(this.formInline.token) + '&brand=' + this.formInline.brands + '&product=' + this.formInline.product, '_parent')
    // },
    async getBrands () {
      var brandsStr = ''
      if (this.formInline.brands && this.formInline.brands.length) {
        this.formInline.brands = [...this.formInline.brands].join(',')
        brandsStr = this.formInline.brands
      }
      const { data: res } = await this.$http.get('/customerBrand/brandList', { params: this.formInline })
      this.brandList = res.rows

      if (brandsStr !== '') {
        await this.$set(this.formInline, 'brands', brandsStr.split(','))
      }
      // console.log('this.brandList.get(0).get(rangeStart) === ' + this.brandList[0].get('rangeStart'))
      // this.total = res.total
    },
    async getCustomers () {
      const { data: res } = await this.$http.get('/customerBrand/allcustomerList4Select')
      this.customerList = res.rows
      // this.total = res.total
    },
    async del (value) {
      const that = this
      this.$confirm('This will permanently delete the Project. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(async () => {
        await that.confirmDelete(value)
        // this.$message({
        //   type: 'success',
        //   message: 'Delete completed!'
        // })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: 'Delete canceled'
        // })
      })
    },
    confirmDelete (value) {
      // Vue.prototype.$http = axios
      const that = this
      this.$http.get('/customerBrand/deleteBrand', { params: { value: value } })
        .then(res => {
          that.getBrands()
          that.$message({
            message: '删除成功',
            type: 'success',
            duration: 500
          })
        })
        .catch(error => {
          console.log(error)
          that.$message({
            message: '删除失败',
            type: 'error'
          })
        })
    },
    dateFormat (row, column, cellValue, index) {
      const daterc = row[column.property]
      // console.log('daterc === ' + daterc)
      if (daterc === null || daterc === '' || daterc === '1753/01/01 00:00:00' || daterc === undefined) {
        return
      }
      var date = new Date(daterc) // long转换成date
      var year = date.getFullYear().toString()
      var month = (date.getMonth() + 1)
      var day = date.getDate().toString()
      // if (month < 10) {
      //   month = '0' + month
      // }
      var monthLetterArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      var monthLetter = monthLetterArr[parseInt(month) - 1]
      if (day < 10) {
        day = '0' + day
      }
      return year + '-' + monthLetter + '-' + day
    },
    nullFormatBlank (row, column, cellValue, index) {
      const daterc = row[column.property]
      // console.log('daterc111===' + daterc)
      if (daterc === 'null' || daterc === null) {
        return ''
      }
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      this.formInline.rows = val
      this.getCRProjects()
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      this.formInline.page = val
      this.getCRProjects()
    }
  }
}
</script>

<style lang="less" scoped="scoped">
  .div-class1 {
    border:solid 1px #000;
    margin-bottom: 15px;
    padding-top:10px;
    // line-height: 50px;
  }
  .div-class {
    border:solid 1px #000;
  }
  .div-class2 {
    border:solid 1px #000;
    padding: 10px;
  }
  .div-project-class {
    border:solid 1px #000;
    padding: 10px;
  }
  .div-title-class {
    border-top:solid 1px #000;
    border-left:solid 1px #000;
    border-right:solid 1px #000;
    color: white;
    text-align: left;
    background-color: rgba(156, 156, 156);
  }
  .div-titlefin-class {
    border-top:solid 1px #000;
    border-left:solid 1px #000;
    border-right:solid 1px #000;
    color: white;
    margin-top:5px;
    background-color: rgba(156, 156, 156);
    text-align: left;
  }
  .dialogTitle{
    text-align: center;
  }

</style>
